import React, { useEffect, useState } from "react";
import pragueHero from '../../static/images/landing_page/prague_hero.jpg';
import LocalizedStrings from "react-localization";
import { DEFAULT_LANGUAGE } from "./App";
const API_BASE = '';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BrokerRegistrationModal from "./BrokerRegistrationModal";

const FLAT_CATEGORY = 1;
const HOUSE_CATEGORY = 2;
const LAND_CATEGORY = 3;
const COMMERCIAL_CATEGORY = 4;
const CONSTRUCTION_PROJECT = 5;
const OTHERS_CATEGORY = 6;

const localizedGeneralInfos = new LocalizedStrings({
    vn: {
        "flats": "Căn hộ",
        "houses": "Nhà hộ gia đình",
        "constructionProjects": "Dự án xây dựng",
        "lands": "Đất",
        "commercialSpaces": "Diện tích kinh doanh",
        "others": "Mục khác"
    },
    cz: {
        "flats": "Byty",
        "houses": "Domy",
        "constructionProjects": "Projekty",
        "lands": "Pozemky",
        "commercialSpaces": "Obchodní prostory",
        "others": "Ostatní"
    }
});

const CATEGORIES = [
    { id: FLAT_CATEGORY,        img: '/static/images/landing_page/flats-city-svgrepo-com.svg',                key: 'flats' },
    { id: HOUSE_CATEGORY,       img: '/static/images/landing_page/aparment-house-svgrepo-com.svg',            key: 'houses' },
    { id: COMMERCIAL_CATEGORY,  img: '/static/images/landing_page/shop-online-shop-svgrepo-com.svg',          key: 'commercialSpaces', priority: true },
    { id: CONSTRUCTION_PROJECT, img: '/static/images/landing_page/cargo-truck-construction-svgrepo-com.svg',  key: 'constructionProjects' },
    { id: LAND_CATEGORY,        img: '/static/images/landing_page/fence-svgrepo-com.svg',                     key: 'lands' },
    { id: OTHERS_CATEGORY,      img: '/static/images/landing_page/garage-svgrepo-com.svg',                    key: 'others' },
];

export default function LandingPage() {
    const navigate = useNavigate();
    const lang = localStorage.getItem("lang") || DEFAULT_LANGUAGE;
    localizedGeneralInfos.setLanguage(lang);
    const [roundedCount, setRoundedCount] = useState(null);
    const [categoryCounts, setCategoryCounts] = useState({});
    const [showRegModal, setShowRegModal] = useState(false);

    useEffect(() => {
        axios.get(`${API_BASE}/api/estate/list/1/?count_estates=true`)
            .then(res => {
                const total = res.data?.estate_count || 0;
                if (total > 0) setRoundedCount(total);
            })
            .catch(() => {});
        axios.get(`${API_BASE}/api/estate/category-counts/`)
            .then(res => setCategoryCounts(res.data || {}))
            .catch(() => {});
    }, []);

    const goSearch = (category) => {
        ['selectedEstateTypeList', 'selectedEstateDispositionList',
         'selectedEstateParameterList', 'selectedEstateConstructionList',
         'selectedEstateStateList', 'selectedEstateOwnershipList',
        ].forEach(k => sessionStorage.removeItem(k));
        sessionStorage.setItem('fromLandingPage', 'true');
        sessionStorage.setItem('estateCategory', String(category));
        navigate('/search/?category=' + category);
    };

    return (
        <div className="landing-page">
            <section className="landing-hero" style={{ backgroundImage: `url(${pragueHero})` }}>
                <div className="landing-hero-inner">
                    {lang !== DEFAULT_LANGUAGE && (
                        <div className="landing-broker-block">
                            <div className="landing-broker-block__toprow">
                                <span className="landing-broker-block__label">Pro realitní kanceláře</span>
                                <a href="/broker-terms/" className="landing-broker-conditions" target="_blank" rel="noopener noreferrer">Podmínky</a>
                            </div>
                            <button
                                className="landing-broker-cta"
                                onClick={() => setShowRegModal(true)}
                            >
                                Registrovat realitní kancelář <span className="landing-broker-cta__arrow">→</span>
                            </button>
                        </div>
                    )}

                    {roundedCount ? (
                        <div className="landing-hero-stat">
                            🏠{' '}
                            <strong>{roundedCount.toLocaleString('cs-CZ')}</strong>
                            {' '}{lang === DEFAULT_LANGUAGE ? 'bất động sản hiện tại' : 'aktuálních nemovitostí'}
                        </div>
                    ) : (
                        <div className="landing-hero-stat landing-hero-stat-skeleton" aria-hidden="true">
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </div>
                    )}
                </div>
            </section>

            <section className="landing-categories">
                <div className="landing-cat-grid">
                    {CATEGORIES.map(({ id, img, key, priority }) => (
                        <div
                            key={id}
                            className="landing-cat-card"
                            data-category={id}
                            onClick={() => goSearch(id)}
                        >
                            <img src={img} alt="" fetchPriority={priority ? 'high' : undefined} />
                            <span>
                                {localizedGeneralInfos[key]}
                                {categoryCounts[id] != null && (
                                    <span className="landing-cat-count"> ({categoryCounts[id].toLocaleString('cs-CZ')})</span>
                                )}
                            </span>
                        </div>
                    ))}
                </div>
            </section>

            {showRegModal && <BrokerRegistrationModal onClose={() => setShowRegModal(false)} />}
        </div>
    );
}
